export const pcgSettingsDevelopment = {"mode":"Development","apiBaseUrl":"https://localhost:5001","rollbarPostClientToken":"fcfcf760457a41dfa8483a51ea51bd8f"};
